var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { EXP_LOCALSTORAGE_PREFIX } from "../constants/LocalStorage.constants.js";
class LocalStorageService {
  constructor(prefix) {
    __publicField(this, "_prefix", "");
    this._prefix = prefix;
  }
  setItem(key, value) {
    let result;
    if (typeof value === "object") {
      result = JSON.stringify(value);
    } else {
      result = `${value}`;
    }
    window.localStorage.setItem(this.getStorageKey(key), result);
  }
  getItem(key) {
    const returnedValueStr = window.localStorage.getItem(this.getStorageKey(key));
    if (returnedValueStr === void 0 || returnedValueStr === null) {
      return null;
    }
    let result;
    try {
      result = JSON.parse(returnedValueStr);
    } catch (e) {
      result = returnedValueStr;
    }
    return result;
  }
  removeItem(key) {
    window.localStorage.removeItem(this.getStorageKey(key));
  }
  getStorageKey(key) {
    return this._prefix + key;
  }
}
const LocalStorageService$1 = new LocalStorageService(EXP_LOCALSTORAGE_PREFIX);
export {
  LocalStorageService$1 as default
};
//# sourceMappingURL=LocalStorageService.js.map
